module.exports = __webpack_public_path__ + "img/MOW_f2ca0f3.webp";